'use client';

import { PageHeader } from '@/shared/layout';
import { Banknote, Clock, RotateCcw, Wallet, ShieldCheck, PenLine, Headphones, type LucideIcon } from 'lucide-react';
import { usePageContent } from '@/core/i18n/content';
import { REFUND_CONTENT } from '@/core/i18n/content/refund.content';

const SECTION_ICONS: LucideIcon[] = [Clock, RotateCcw, Wallet, ShieldCheck, PenLine, Banknote, Headphones];

export function RefundPolicy() {
  const c = usePageContent(REFUND_CONTENT);

  return (
    <div id="legal-refund-root" className="min-h-screen bg-hms-bg">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <PageHeader title={c.title} description={c.description} />
        <p id="legal-refund-intro" className="mt-6 text-sm text-hms-textSub leading-relaxed">
          {c.intro}
        </p>
        <div id="legal-refund-sections" className="mt-8 space-y-6">
          {c.sections.map((section, idx) => {
            const Icon = SECTION_ICONS[idx] || Clock;
            return (
              <section key={idx} id={`legal-refund-section-${idx}`} className="rounded-xl border border-hms-border bg-hms-card p-6 space-y-3">
                <h2 className="text-base font-semibold text-hms-text flex items-center gap-2">
                  <Icon className="h-4 w-4 text-hms-gold" />
                  {section.title}
                </h2>
                {section.items ? (
                  <ul className="space-y-2 text-sm text-hms-textSub leading-relaxed list-none">
                    {section.items.map((item, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-hms-gold/60" />
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-hms-textSub leading-relaxed">{section.content}</p>
                )}
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}
